<div class="container mt-5">
  <div *ngIf="medicineReminderContent">
    
    <div [innerHTML]="medicineReminderContent.body"></div>
  </div>
  <app-download-section></app-download-section>
</div>
